<template>
  <div class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Bulk delete</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Do you really want to delete selected entries?</p>
          <p>This action can not be reverted!</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" @click="confirm()">
            Delete
          </button>
          <button type="button" class="btn btn-secondary" @click="close()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    confirm () {
      this.done(true)
    }
  }
}
</script>
